<script>
export default {
  data() {
    return {
      data_config: {
        total: 0,
        page: 1,
        rows: 10,
        list: [],
        product_name: "",
        goods_classify_id: "",
      },
      goodsClassifyValue: [],
      accessory_classify_list: [],
    };
  },
  created() {
    this.getAccessoryClassify();
    this.getDataList(1);
  },
  mounted() {},
  methods: {
    handleClassifyChange(value) {
      this.data_config.goods_classify_id = Array.isArray(value) && value.length ? value[value.length - 1] : "";
    },
    handleEdit(row) {
      this.$router.push(`/sourceGoods/accessory/edit/${row.id}`);
    },
    dataUpdateData(val, status) {
      if (status == 0) {
        this.data_config.rows = val;
      } else {
        this.data_config.page = val;
      }
      this.getDataList();
    },
    getDataList(style) {
      if (style) this.data_config.page = 1;
      let obj = {
        page: this.data_config.page,
        rows: this.data_config.rows,
      };
      if (this.data_config.product_name)obj.product_name = this.data_config.product_name;
      if (this.data_config.goods_classify_id) obj.goods_classify_id = this.data_config.goods_classify_id;
      this.$axios
        .post(this.$api.sourceGoods.accessory_list, obj)
        .then((res) => {
          if (res.code == 0) {
            this.data_config.total = res.result.total_number;
            this.data_config.list = res.result.list;
          }
        });
    },
    cancleSearch() {
      this.data_config.product_name = "";
      this.data_config.goods_classify_id = "";
      this.goodsClassifyValue = [];
      this.getDataList(1);
    },
    getAccessoryClassify() {
      this.$axios
        .post(this.$api.sourceGoods.accessory_classify, {
          page: 1,
          rows: 100,
        })
        .then((res) => {
          if (res.code == 0) {
            this.accessory_classify_list = res.result.list || res.result || [];
          }
        });
    },
  },
};
</script>
<template>
  <el-main>
    <el-button
      class="add_component_btn"
      type="primary"
      icon="el-icon-plus"
      size="small"
      style="margin-bottom: 16px"
	  @click="$router.push('/sourceGoods/accessory/add')"
      >新增配件</el-button
    >
    <el-form class="el-form-search" label-width="100px">
      <el-form-item label="配件名称：">
        <el-input
          size="small"
          placeholder="请输入"
          v-model.trim="data_config.product_name"
        ></el-input>
      </el-form-item>
      <el-form-item label="配件分类：">
        <el-cascader
          v-model="goodsClassifyValue"
          size="small"
          clearable
          :options="accessory_classify_list"
          :props="{ value: 'id', label: 'name', children: '_child', expandTrigger: 'hover' }"
          placeholder="请选择配件分类"
          @change="handleClassifyChange"
        ></el-cascader>
      </el-form-item>
      <el-form-item label=" " label-width="25px">
        <el-button size="small" type="primary" @click="getDataList(1)"
          >搜索</el-button
        >
        <el-button type="text" size="small" @click="cancleSearch"
          >清空搜索条件</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :data="data_config.list"
      :header-cell-style="{ 'background-color': '#F8F9FA' }"
    >
      <template slot="empty">
        <No></No>
      </template>
      <el-table-column label="配件名称" align="center">
        <template v-slot="{ row }">
          {{ row.goods_name }}
        </template>
      </el-table-column>
      <el-table-column label="配件简介" align="center">
        <template v-slot="{ row }">
          {{ row.goods_subtitle || "--" }}
        </template>
      </el-table-column>
      <el-table-column label="价格" align="center">
        <template v-slot="{ row }">
          <div style="text-align: center">
            <el-link :underline="false" type="primary"
              >零售价:{{ row.price }}</el-link
            >
          </div>
          <div style="text-align: center">
            <el-link :underline="false" type="warning"
              >同行价:{{ row.goods_price }}</el-link
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template v-slot="{ row }">
          <el-tooltip effect="light" content="编辑" placement="top-start">
            <el-button
              type="primary"
              icon="el-icon-edit"
              circle
              size="mini"
              @click="handleEdit(row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip effect="light" content="删除" placement="top-start">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              size="mini"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <Paging
      :total="data_config.total"
      :page="data_config.page"
      :pageNum="data_config.rows"
      @updatePageNum="dataUpdateData"
    ></Paging>
  </el-main>
</template>
<style lang="less" scoped>
.el-main {
  width: 100%;
  background: #fff;
  height: 100%;
}
</style>
